var HashMap = require("./hashMap.js");
var inherit = require("../general.js").inherit;

var HashSet = function (hash) {
    HashMap.call(this, hash);
};
inherit(HashSet, HashMap);

HashSet.prototype.add = function(val){
    return HashMap.prototype.put.call(this, val, val);
};
HashSet.prototype.put = undefined;

HashSet.prototype.forEachPair = function(f, includeEquals){
    HashMap.prototype.forEachPair.call(this, function(k0, v0,k1,v1){
        f(v0, v1);
    }, includeEquals);
};

HashSet.prototype.addAll = function(col){
    var self = this;

    if (col instanceof HashSet) {
        col.forEach(function(val) {
            self.add(val);
        });
    } else if (col instanceof HashMap) {
        col.forEach(function(key, val) {
            self.add(val);
        });
    } else if (col instanceof Array) {
        for (var i=0; i<col.length; i++) {
            this.add(col[i]);
        }
    }
};

HashSet.prototype.pop = function(){
    return this.remove(this.getOne());
};

HashSet.prototype.copy = function() {
    var result = new HashSet(this._hash);
    result.addAll(this);
    return result;
};

HashSet.prototype.filter = function(f){
    var result = new HashSet(this._hash);
    this.forEach(function(val){
        if (f(val, val)) result.add(val);
    });
    return result;
};

HashSet.prototype.map = function(f){
    var result = new HashSet(this._hash);
    this.forEach(function(val){
        result.add(f(val, val));
    });
    return result;
};

HashSet.prototype.union = function(other){
    return this.filter(function(el){
        return other.contains(el);
    });
};

HashSet.prototype.toArray = function() {
    return this.values();
};

HashSet.prototype.equals = function(set, compare) {
    if(!compare) {
        return this.size() === set.size() && this.containsAll(set);
    } else {
        var unvisited = new HashSet();
        unvisited.addAll(set);
        var res = this.every(function(val1) {
            return unvisited.some(function(val2) {
                if(compare(val1, val2)) {
                    unvisited.remove(val2);
                    return true;
                } else return false;
            });
        });
        return res && unvisited.size() === 0;
    }
};

module.exports = HashSet;
